<template>
  <div class="icpBack">
    <div class="textInfo" style="margin-top: 80px;margin-bottom: 80px;">
      Copyright © 2024-2034 Green Wheat Network Technology Co.Ltd All Rights
      Reserved.
    </div>
    <div class="textInfo" style="margin-bottom: 80px;">陕ICP备2021011694号</div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.icpBack {
  background-color: rgb(94, 100, 105);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.textInfo {
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}
</style>